"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import {
  captureUTMParams,
  trackPageView,
  trackUserReturn,
  trackFunnelStep,
} from "@/lib/analytics";

/**
 * Analytics Provider
 * Automatically tracks:
 * - Page views (US-300)
 * - UTM params capture (US-302)
 * - User retention (US-305)
 * - Landing page funnel (US-307)
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Capture UTM params and track retention on mount
  useEffect(() => {
    captureUTMParams();
    trackUserReturn();
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (pathname) {
      trackPageView(pathname, document.title);

      // Track funnel steps based on page
      if (pathname === "/") {
        trackFunnelStep("landing_view");
      } else if (pathname === "/register") {
        trackFunnelStep("register_start");
      } else if (pathname === "/verify-email") {
        // Email verification page
      } else if (pathname === "/dashboard") {
        // User reached dashboard
      }
    }
  }, [pathname, searchParams]);

  return <>{children}</>;
}
